export default __webpack_public_path__ + "static/lframe-cards-3d1ad7daa096530cc2f8b315b9c5cce4.png";